import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';

import { ButtonComponent } from '../form';
import { ProgressBarComponent } from '../progress-bar';
import { StatusItem } from './status-item-list.model';

/**
 * List of items with status, progress and an optional link button, e.g. the files/imports behind a status cell.
 *
 * ```html
 * <dmb-status-item-list [items]="items" emptyText="Nothing imported" (navigated)="close()" />
 * ```
 */
@Component({
  selector: 'dmb-status-item-list',
  templateUrl: './status-item-list.component.html',
  styleUrl: './status-item-list.component.scss',
  imports: [ButtonComponent, ProgressBarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusItemListComponent {
  private readonly router = inject(Router);

  readonly items = input.required<readonly StatusItem[]>();
  readonly emptyText = input('No items');

  /** Emitted after navigating to an item's link, e.g. to close a surrounding dialog */
  readonly navigated = output<StatusItem>();

  async open(item: StatusItem) {
    if (!item.link) {
      return;
    }
    this.navigated.emit(item);
    await this.router.navigate([item.link.url], { queryParams: item.link.queryParams });
  }
}
